import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';

import Appearance from 'styles/Appearance.js';
import { getIcon } from 'views/TextField.js';

const DatePickerField = props => {

    const { dateTime, fieldStyle, icon, insetLabel, insetContainerStyle, insetLabelStyle, onDateChange, onFormat, onRemoveDate, onValidate, placeholder, selected } = props;

    const [active, setActive] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);

    const onFieldClick = () => {
        setActive(true);
        props.utils.datePicker.show({
            date: selectedDate,
            ...props,
            onDateChange: onInnerDateChange,
            onRemoveDate: onInnerRemoveDate,
            onClose: () => setActive(false)
        })
    }

    const onFormatDate = () => {
        if(!selectedDate) {
            return placeholder || 'Select a date...';
        }
        if(typeof(onFormat) === 'function') {
            return onFormat(selectedDate);
        }
        if(dateTime) {
            return moment(selectedDate).format('MMMM Do, YYYY [at] h:mma')
        }
        return moment(selectedDate).format('MMMM Do, YYYY');
    }

    const onInnerDateChange = date => {
        setSelectedDate(date);
        if(typeof(onDateChange) === 'function') {
            onDateChange(date);
        }
    }

    const onInnerRemoveDate = () => {
        setSelectedDate(null);
        if(typeof(onRemoveDate) === 'function') {
            onRemoveDate();
        }
    }

    const getLocalIcon = () => {
        return icon ? getIcon(icon) : null;
    }

    const getTextColor = () => {
        if(!selectedDate) {
            return Appearance.colors.subText();
        }
        return Appearance.colors.text();
    }

    useEffect(() => {
        setSelectedDate(selected ? moment(selected) : null);
    }, [selected]);

    return (
        <div
        onClick={onFieldClick}
        className={`dummy-field ${active ? 'active' : ''} ${window.theme} cursor-pointer`}
        style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            flexGrow: 1,
            position: 'relative',
            height: 35,
            textAlign: 'left',
            backgroundColor: Appearance.colors.textField(),
            borderColor: Appearance.colors.divider(),
            ...props.style
        }}>
            {getLocalIcon() && (
                <div style={{
                    paddingRight: 8,
                    marginLeft: 4
                }}>
                    <i
                    className={getLocalIcon()}
                    style={{
                        marginRight: 8,
                        color: Appearance.colors.icon(),
                        fontSize: 13
                    }}/>
                </div>
            )}
            {typeof(insetLabel) === 'string' && (
                <div style={{
                    marginRight: 8,
                    paddingRight: 8,
                    borderRight: `1px solid ${Appearance.colors.softBorder()}`,
                    ...insetContainerStyle
                }}>
                    <span style={{
                        color: Appearance.colors.subText(),
                        display: 'block',
                        fontSize: 10,
                        fontWeight: '600',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        ...insetLabelStyle
                    }}>{insetLabel.toUpperCase()}</span>
                </div>
            )}
            <span style={{
                fontSize: 12,
                fontWeight: 500,
                color: getTextColor(),
                width: '100%',
                flexGrow: 1,
                ...fieldStyle
            }}>{onFormatDate()}</span>
            {typeof(onValidate) === 'function' && onValidate(selectedDate) && (
                <img
                src={'images/checkmark-small-green.png'}
                style={{
                    width: 15,
                    height: 15,
                    objectFit: 'contain',
                    marginLeft: 8
                }} />
            )}
        </div>
    )
}
export default DatePickerField;
